import { Heating } from "@/pages/heat-report/models/HeatReportModels";
import { dxtToLocalServerTime, getMomentTz } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef, ValueGetterParams } from "ag-grid-enterprise";
const moment = getMomentTz();

export const useTableData = () => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Heatings",
      children: [
        {
          field: "StartTime",
          headerName: "Start",
          flex: 1,
          minWidth: 70,
          valueGetter: (params: ValueGetterParams) => {
            if (params.data.StartTime) {
              return dxtToLocalServerTime(
                (params.data as Heating).StartTime,
                "HH:mm:ss",
              );
            }
          },
        },
        {
          field: "EndTime",
          headerName: "End",
          flex: 1,
          minWidth: 70,
          valueGetter: (params: ValueGetterParams) => {
            if (params.data.EndTime) {
              return dxtToLocalServerTime(
                (params.data as Heating).EndTime,
                "HH:mm:ss",
              );
            }
          },
        },
        {
          field: "Duration",
          headerName: "Duration",
          flex: 1,
          minWidth: 85,
          valueGetter: (params: ValueGetterParams) => {
            const { StartTime, EndTime } = params.data as Heating;

            if (EndTime && StartTime) {
              const durationInSeconds = moment(EndTime).diff(
                moment(StartTime),
                "seconds",
              );

              if (isNaN(durationInSeconds)) {
                return "";
              }
              const minutes = Math.floor(durationInSeconds / 60);
              const seconds = durationInSeconds % 60;
              return `${minutes.toString().padStart(2, "0")}:${seconds
                .toString()
                .padStart(2, "0")}`;
            }
          },
        },
        {
          field: "Energy",
          headerName: "Energy [kWh]",
          flex: 1,
          minWidth: 125,
        },
      ],
    },
  ];

  return { columns };
};
